"use client";

import Link from "next/link";
import Sidebar from "@/components/sideBar/SideBar";
import CommonCard from "@/components/commonCard/CommonCard";
import NewsLetter from "@/components/newsletter/NewsLetter";
import { useEffect, useState } from "react";
import { Post, SidebarApiResponse } from "@/types/post.types";
import "./style.css";
import Image from "next/image";
import Breadcrumbs from "../breadCrumbAndButton/BreadCrumbAndButton";
import AdSpace from "@/components/ads/Adspace";
import PostSkeleton from "@/components/skeletons/PostSkeleton";
import type { AdItem } from "@/lib/getAdSpaceData";

interface CategoryPost {
  category_id?: string;
  title?: string;
  title_slug?: string;
  image_url?: string;
  image_small?: string;
  image_slider?: string;
  image_default?: string;
  image_mid?: string;
  category_name?: string;
  category_slug?: string;
  category_color?: string;
  sub_category_name?: string;
  sub_category_slug?: string;
  sub_category_color?: string;
  author_slug?: string;
  author_username?: string;
  summary?: string;
  created_at?: string;
  image_big?: string;
}

interface Props {
  categoryNews: CategoryPost[];
  categoryDetail: any;
  breakingNews: Post[];
  featuredPosts: Post[];
  totalPosts: number;
  hasMoreInitially: boolean;
  initialAds: AdItem[];
}

const formatTitle = (slug?: string) =>
  slug?.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()) || "";

export default function NewsArchive({
  categoryDetail,
  categoryNews,
  breakingNews,
  featuredPosts,
  totalPosts: initialTotalPosts,
  hasMoreInitially,
  initialAds,
}: Props) {
  const [loading, setLoading] = useState(false);
  // const [breakingNews, setBreakingNews] = useState<Post[]>([]);
  // const [featuredPosts, setFeaturedPosts] = useState<Post[]>([]);
  const [hasAd, setHasAd] = useState(false);

  const [totalPosts, setTotalPosts] = useState(initialTotalPosts);
  const [displayedNews, setDisplayedNews] = useState(categoryNews);
  const [hasMore, setHasMore] = useState(hasMoreInitially);
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const PAGE_SIZE = 12;

  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {
  //       const res = await fetch("/api/homepage-data");
  //       if (!res.ok) throw new Error("Failed to fetch homepage data");

  //       const data: SidebarApiResponse = await res.json();
  //       setBreakingNews(data.breakingNews);
  //       setFeaturedPosts(data.featuredPosts);
  //     } catch (error) {
  //       console.error("Homepage data fetch error:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, []);
  // console.log("breakingNews", breakingNews);
  // console.log("featuredPosts", featuredPosts);
  console.log("categoryDetail", categoryDetail);
  console.log("categoryNews", categoryNews);

  const BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || "";

  const getImage = (item: any) => {
    const path =
      item.image_url?.trim() ||
      BASE_URL + '/' + item.image_big?.trim() ||
      BASE_URL + '/' + item.image_default?.trim() ||
      BASE_URL + '/' + item.image_slider?.trim() ||
      BASE_URL + '/' + item.image_mid?.trim() ||
      BASE_URL + '/' + item.image_small?.trim();

    return path ? path : "/image-not-found.png";
  };

  console.log("categoryDetail", categoryDetail);

  // Simpler version — no API needed if all posts are already in props
  const handleLoadMore = async () => {
    if (loadingMore || !hasMore) return;

    const nextPage = page + 1;
    setPage(nextPage);
    setLoadingMore(true);

    try {
      // ← fix: read the correct slug field from categoryDetail
      const slug =
        categoryDetail?.name_slug ??
        categoryDetail?.category_slug ??
        categoryDetail?.slug ??
        "";

      if (!slug) {
        console.error(
          "No slug found in categoryDetail:",
          Object.keys(categoryDetail ?? {}),
        );
        return;
      }

      const res = await fetch(
        `/api/category-news?slug=${slug}&page=${nextPage}&limit=${PAGE_SIZE}`,
      );
      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      const newPosts: CategoryPost[] = data?.posts ?? [];

      // Use hasMore flag from API response
      if (typeof data?.hasMore === "boolean") {
        setHasMore(data.hasMore);
      } else {
        // Fallback if API doesn't return hasMore
        if (newPosts.length < PAGE_SIZE) setHasMore(false);
      }

      if (typeof data?.total === "number" && data.total > 0) {
        setTotalPosts(data.total);
      }

      setDisplayedNews((prev) => [...prev, ...newPosts]);
    } catch (err) {
      console.error("Load more failed:", err);
    } finally {
      setLoadingMore(false);
    }
  };

  return (
    <>
      <div className="top-header-padding ">
        <div className="gh-container ">
          {/* Main Content Section */}
          <div className="pt-md-4 pb-3 mb-2">
            <Breadcrumbs
              items={[
                {
                  label: "Home",
                  href: process.env.NEXT_PUBLIC_SITE_URL ?? "/",
                },
                ...(categoryDetail?.parent_slug
                  ? [
                    {
                      label: formatTitle(categoryDetail.parent_slug),
                      href: categoryDetail.parent_slug,
                    },
                  ]
                  : []),
                ...(categoryDetail?.name
                  ? [{ label: categoryDetail.name }]
                  : []),
              ]}
            />
          </div>
          <AdSpace
            slot="post_top"
            viewport="auto"
            initialAds={initialAds}
            onRender={(rendered) => setHasAd(rendered)}
          />
          <div className="pb-5">
            <div className="row">
              {/* LEFT */}
              <div className="col-12">
                <main className="post-page-main category-page">
                  {/* Breadcrumbs */}

                  {/* Category Header */}
                  <div className="category-page-header with-image mb-4">
                    {/* ── REPLACE your existing <picture> + h1 + p block with this ── */}

                    <div
                      className="category-page-header with-image"
                      style={{
                        position: "relative",
                        width: "100%",
                        height: "555px",
                        borderRadius: "12px",
                        overflow: "hidden",
                        background: "#111",
                      }}
                    >
                      {/* Background image — dimmed ~50%, zoomed slightly */}
                      <Image
                        className="category-page-feature-image"
                        src={BASE_URL + '/' + categoryDetail.bg_image}
                        fill
                        sizes="(max-width: 768px) 100vw, 1440px"
                        style={{
                          objectFit: "cover",
                          objectPosition: "center",
                          filter: "brightness(0.52)",
                          transform: "scale(1.04)",
                          transition: "transform 8s ease",
                        }}
                        alt={categoryDetail?.name || "Category"}
                        priority
                      />

                      {/* Soft dark overlay */}
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,
                          background: "rgba(0,0,0,0.18)",
                        }}
                      />

                      {/* Text content — bottom-left */}
                      <div
                        style={{
                          position: "absolute",
                          inset: 0,
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "flex-end",
                          padding:
                            "clamp(24px, 4vw, 48px) clamp(20px, 4vw, 56px)",
                        }}
                      >
                        {/* Category badge */}
                        {/* <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "6px",
                            background: "rgba(255,255,255,0.12)",
                            border: "0.5px solid rgba(255,255,255,0.25)",
                            borderRadius: "100px",
                            padding: "5px 14px",
                            fontSize: "11px",
                            color: "rgba(255,255,255,0.85)",
                            letterSpacing: "0.06em",
                            textTransform: "uppercase",
                            marginBottom: "14px",
                            width: "fit-content",
                          }}
                        >
                          <span
                            style={{
                              width: "6px",
                              height: "6px",
                              borderRadius: "50%",
                              background: "#6ee7b7",
                              flexShrink: 0,
                              display: "inline-block",
                            }}
                          />
                          Category
                        </div> */}

                        {/* Name */}
                        <h1
                          style={{
                            fontSize: "clamp(32px, 4vw, 52px)",
                            fontWeight: 700,
                            color: "#fff",
                            lineHeight: 1.1,
                            letterSpacing: "-0.02em",
                            margin: "0 0 14px",
                            fontFamily: "Epilogue",
                          }}
                        >
                          {categoryDetail?.name}
                        </h1>

                        {/* Description */}
                        <p
                          style={{
                            fontSize: "clamp(14px, 1.2vw, 20px)",
                            color: "rgba(255,255,255)",
                            lineHeight: 1.4,
                            maxWidth: "800px",
                            margin: "0 0 20px",
                            fontWeight: 500,
                          }}
                        >
                          {categoryDetail?.description}
                        </p>

                        {/* Post count */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                            fontSize: "13px",
                            color: "rgba(255,255,255,0.55)",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "clamp(14px, 1.2vw, 20px)",
                              fontWeight: 600,
                              color: "rgba(255,255,255, 0.80)",
                            }}
                          >
                            {initialTotalPosts > 0
                              ? `${initialTotalPosts} Posts`
                              : `${displayedNews.length}${hasMore ? "+" : ""} Posts`}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Posts Grid - Using CommonCard for consistency */}
                  <section className="archive-feed-wrapper">
                    <div className="row g-4">
                      {displayedNews.map(
                        (
                          {
                            category_id,
                            title,
                            title_slug,
                            author_username,
                            image_url,
                            image_small,
                            image_slider,
                            image_default,
                            image_big,
                            image_mid,
                            category_name,
                            category_slug,
                            category_color,
                            created_at,
                            sub_category_name,
                            sub_category_slug,
                            sub_category_color,
                            author_slug,
                            summary,
                          },
                          index,
                        ) => (
                          <div
                            className="col-12 col-md-4 card-container px-0 mx-0"
                            key={index}
                          >
                            <CommonCard
                              bodyClassName="px-0"
                              titleClassName="post-card-text section-card px-0 mx-0"
                              authorName={
                                author_username || "author username not found"
                              }
                              publishDate={created_at || "Date not found"}
                              titleText={title || "title not found"}
                              imgSrc={getImage({
                                image_url,
                                image_big,
                                image_default,
                                image_slider,
                                image_mid,
                                image_small,
                              })}
                              category_name={category_name || ""}
                              category_slug={category_slug || ""}
                              category_color={category_color || ""}
                              sub_category_name={sub_category_name || ""}
                              sub_category_slug={sub_category_slug || ""}
                              sub_category_color={sub_category_color || ""}
                              // cardLink={`/${category_slug}/${title_slug}` || "#"}
                              cardLink={`/${title_slug}` || "#"}
                              responsiveimageClassName="responsive-image" // remove fixed width/height from here
                              imageWrapperClassName="responsive-image-wrapper"
                              authorSlug={`${author_slug}` || ""}
                              authorSlugClassName="authors-slug"
                            />
                          </div>
                        ),
                      )}
                    </div>
                  </section>
                  <div className="text-center mt-md-3 px-md-3 px-2">
                    {loadingMore && (
                      <div className="row g-3">
                        {Array.from({ length: 3 }).map((_, i) => (
                          <div className="col-12 col-md-4" key={i}>
                            <PostSkeleton />
                          </div>
                        ))}
                      </div>
                    )}
                    {!loadingMore && hasMore && (
                      <div className="d-flex justify-content-center mt-2 mb-4">
                        <button
                          className="newsletter-submit-loading-button"
                          onClick={handleLoadMore}
                        >
                          Load More
                        </button>
                      </div>
                    )}
                  </div>
                </main>
              </div>
            </div>
          </div>
        </div>
        {/* Newsletter Section */}
        <AdSpace
          slot="post_bottom"
          viewport="auto"
          initialAds={initialAds}
          onRender={(rendered) => setHasAd(rendered)}
        />
        <NewsLetter />
      </div>
    </>
  );
}
